import React, { useState } from "react";
import "./ECCoursePage.scss";
import { useNavigate } from "react-router-dom";
import I1 from '../../assets/images/eclab/IMG-20190327-WA0013.jpg';
import I2 from '../../assets/images/eclab/IMG-20190327-WA0014.jpg';
import I3 from '../../assets/images/eclab/IMG-20190327-WA0015.jpg';
import I4 from '../../assets/images/eclab/IMG-20190327-WA0016.jpg';
import I5 from '../../assets/images/eclab/IMG-20190327-WA0019.jpg';
import I6 from '../../assets/images/eclab/IMG-20190327-WA0020.jpg';
import I7 from '../../assets/images/eclab/IMG-20190327-WA0021.jpg';
import I8 from '../../assets/images/eclab/IMG-20190327-WA0022.jpg';
import I9 from '../../assets/images/eclab/IMG-20190327-WA0023.jpg';
import I10 from '../../assets/images/eclab/IMG-20190327-WA0024.jpg';
import I11 from '../../assets/images/eclab/IMG_20190327_161507874.jpg';
import I12 from '../../assets/images/eclab/IMG_20190327_161625227.jpg';

const ECCoursePage: React.FC = () => {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const images = [
    I1,
    I2,
    I3,
    I4,
    I5,
    I6,
    I7,
    I8,
    I9,
    I10,
    I11,
    I12
  ];

  return (
    <div className="ec-course-page">
      {/* Hero Section */}
      <section className="hero">
        <h1>Electronics & Communication Engineering</h1>
        <p>Explore the world of technology and innovation with our Diploma in EC.</p>
      </section>

      {/* About EC Department */}
      <section className="about-ec">
        <h2>About EC Diploma</h2>
        <p>
          The Electronics & Communication (EC) Engineering diploma program provides a 
          strong foundation in electronics, signal processing, and communication technologies. 
          The curriculum is designed to equip students with industry-relevant skills.
        </p>
      </section>

      {/* Labs & Infrastructure */}
      <section className="labs">
        <h2>EC Labs & Infrastructure</h2>
        <div className="labs-grid">
          <div className="lab-card">
            <h3>Microprocessor Lab</h3>
            <p>Hands-on experience with microcontrollers and embedded systems.</p>
          </div>
          <div className="lab-card">
            <h3>Communication Lab</h3>
            <p>Study of modulation, transmission, and wireless communication.</p>
          </div>
          <div className="lab-card">
            <h3>Digital Electronics Lab</h3>
            <p>Practical exposure to digital circuits, logic gates, and ICs.</p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery">
      <h2>EC Labs & Campus Tour</h2>
      <div className="gallery-grid">
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Lab ${index + 1}`}
            className="gallery-img"
            onClick={() => setSelectedImage(src)}
          />
        ))}
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Enlarged View" className="lightbox-img" />
        </div>
      )}
    </section>
    </div>
  );
};

export default ECCoursePage;
